import { gql } from "apollo-boost";

export const CREATE_SUBBRAND = gql`
mutation CreateSubBrand($data: SubBrandInput) {
    createSubBrand(data: $data) {
      id
    }
  }
`

export const UPDATE_SUBBRAND = gql`
mutation UpdateSubBrand($where: SubBrandWhereInputOne!, $data: SubBrandInput) {
  updateSubBrand(where: $where, data: $data) {
    id
  }
}
`


export const DELETE_SUBBRAND = gql`
mutation DeleteSubBrand($where: SubBrandWhereInputOne!) {
  deleteSubBrand(where: $where) {
    id
  }
}
`